module.exports = __webpack_public_path__ + "static/media/survey-kuisioner.8b77f003.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/survey-img/survey-kuisioner.png
// module id = 1462
// module chunks = 0